var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Avintercomsplay"},[_c('video',{staticClass:"videoo1",attrs:{"id":_vm.videoid,"autoplay":"","webkit-playsinline":"","playsinline":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }